define('app/models/Segment',['require','./AnalyticsEntity','config','app/models/CompoundFilter','glu/collection','app/app','glu/util','glu/$'],function(require) {
	'use strict';

	var AnalyticsEntity = require('./AnalyticsEntity'),
		config = require('config'),
		CompoundFilter = require('app/models/CompoundFilter'),
		Collection = require('glu/collection'),
		App = require('app/app'),
		_ = require('glu/util'),
		$ = require('glu/$');

	/**
	 * A Segment is similar to a Report in the way that it refines a SQL query to be created and executed,
	 * but differs in that it will always be targeted towards producing company name, address and email as output.
	 */
	var Segment = AnalyticsEntity.extend({

		url: function() {
			return config.apiRoot + 'service/segments/' + this.id;
		},

		getDomain: function() {
			return App.domains.get(this.get('domainId'));
		},

		getDomainId: function() {
			return this.get('domainId');
		},

		setDomainId: function(domainId) {
			return this.set('domainId', domainId);
		},

		getFilter: function() {
			return this.get('filters');
		},

		setFilter: function(value) {
			var cleanValue = [],
				filter;

			for (var i = 0; i < value.get('filterCollection').length; i++) {
				if (value.get('filterCollection').models[i].get('selected') && !value.get('filterCollection').models[i].get('segmentId')) {
					cleanValue.push(value.get('filterCollection').models[i]);
				}
			}

			filter = new CompoundFilter({
				operator: 'AND',
				filterCollection: new Collection(cleanValue)
			});

			return this.set('filters', filter);
		},

		toJSON: function() {

			var serialized = {};

			serialized.id = this.get('id');
			serialized.domainId = this.get('domainId');
			serialized.isPrivate = this.getIsPrivate();

			serialized.name = this.get('name');
			serialized.description = this.get('description');

			serialized.filters = this.get('filters');

			return serialized;
		},

		save: function() {
			// Create a usable plain object to remove unselected filters
			var data = JSON.parse(JSON.stringify(this.toJSON()));

			return $.ajax(config.apiRoot + 'service/segments', {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data)
			}).then(function(res) {
				return res.id;
			});
		},

		isOwner: function() {
			return this.get('owner') === App.user.getUsername();
		},

		parse1: function(data) {
			var domain = App.domains.get(data.domainId);
			var constructorData = {
				id: data.id,
				name: data.name,
				description: data.description,
				domainId: data.domainId,
				owner: data.owner,
				isPrivate: data.isPrivate,
				isDeleted: data.isDeleted,
				dateModified: data.dateModified,
				dateCreated: data.dateCreated
			};

			// Set filters
			if (data.filters) {
				constructorData.filters = domain ? domain.buildFilter(data.filters) : null;
			} else {
				constructorData.filters = domain ? domain.buildCompoundFilter({
					operator: 'AND'
				}) : null;
			}

			return constructorData;
		},

		clone: function() {
			var attributes = _.clone(this.attributes);
			attributes.options = _.clone(this.attributes.options);
			attributes.filters = _.clone(attributes.filters);
			return new this.constructor(attributes);
		}
	});

	return Segment;
});

